import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import NavigationWrapper from '../components/NavigationWrapper';
import FooterWrapper from '../components/FooterWrapper';
import philteamfoto from '../assets/about/Phil_Teamfoto.webp';
import blcks_icon_white from '../assets/icons/blcks_icon_white.svg';

const Blog = () => {
  const [activeFilter, setActiveFilter] = useState('Alle Posts');

  const filters = [
    'Alle Posts',
    'Allgemein',
    'Engineering',
    'Community',
    'Unternehmens News',
    'Kunden',
  ];

  // Sample blog posts data
  const mainPosts = [
    {
      id: 1,
      slug: 'leitfaden-fuer-effizienzsteigerung',
      date: 'Okt 21',
      title: 'Wie man von manuellen Arbeitsabläufen zu KI-gesteuerter Auto-matisierung wechselt',
      excerpt: 'Die meisten Unternehmen sind in einem selbstgeschaffenen Gefängnis aus manuellen Arbeitsabläufen gefangen. Stellen Sie sich vor: Es ist 2025, und Ihre Konkurrenz nutzt KI, um Dokumente in Sekunden zu verarbeiten, während Ihr Team immer noch Stunden damit verbringt, Daten zwischen Excel-Tabellen hin und her zu kopieren. Sie liefern Kundenantworten in Minuten, während Sie noch E-Mails hin....',
      author: 'Philipp Fuchs',
      category: 'Allgemein'
    },
    {
      id: 2,
      slug: 'excel-tabelle-emails-hope',
      date: 'Okt 18',
      title: 'Die meisten Unternehmen arbeiten immer noch mit Tabellen, E-Mails und Hoffnung in 2025',
      excerpt: 'Die meisten Unternehmen ertrinken in manuellen Prozessen, während Automatisierungstools ungenutzt bleiben. Hier ist, warum die Lücke zwischen dem Möglichen und dem tatsächlich Umgesetzten Unternehmen Millionen kostet. Stellen Sie sich vor: Es ist 2025 und Sie sitzen in einer Vorstandssitzung, in der der CEO eine "bahnbrechende Digitalisierungsinitiative" ankündigt....',
      author: 'Philipp Fuchs',
      category: 'Allgemein'
    },
    {
      id: 3,
      slug: 'back-office-automations',
      date: 'Okt 10',
      title: '6 Backoffice Auto-matisierungen, die Großhandels-, Fertigungs- und Logistikunternehmen nicht ignorieren können',
      excerpt: 'Stellen Sie sich vor: Es ist Freitag, 15 Uhr. Ihr Großhandelsbetrieb hat gerade 47 Verkaufsaufträge per E-Mail, Fax und über das uralte Portal erhalten, das Ihr größter Kunde partout weiter nutzen möchte. Währenddessen versucht Ihre Fertigungsabteilung herauszufinden, ob die Produktion für nächste Woche überhaupt realisierbar ist, weil niemand die tatsä....',
      author: 'Philipp Fuchs',
      category: 'Allgemein'
    }
  ];

  const latestNews = [
    {
      id: 4,
      slug: 'ki-basierte-wissensdatenbanken',
      date: 'Okt 03',
      title: 'KI-basierte Wissens- datenbanken: Die Zukunft des Wissensmanagements',
      excerpt: 'Entdecken Sie, wie KI-gestützte Wissensdatenbanken das Paradoxon von Informationsüberfluss und Wissens- mangel beenden, Mitarbeitern 8-10...',
      author: 'Philipp Fuchs',
      category: 'Allgemein'
    },
    {
      id: 5,
      slug: 'ai-agents-vs-workflows',
      date: 'Sep 18',
      title: 'KI Agents vs. Workflows: Was ist der Unterschied?',
      excerpt: 'Künstliche Intelligenz bietet Unternehmen eine unglaubliche Chance, viele ihrer Abläufe zu automatisieren. Aber nicht alle Automatisierung funktioniert gleich. Wenn Sie auf...',
      author: 'Philipp Fuchs',
      category: 'Allgemein'
    },
    {
      id: 6,
      slug: 'kundensupport-automatisierung',
      date: 'Sep 03',
      title: 'Kundensupportautomatisierung, die wirklich funktioniert',
      excerpt: 'Stellen Sie sich vor: Sie müssen ein defektes Produkt zurücksenden. Sie klicken auf "Chatten Sie mit uns" und landen sofort in der Chatbot-Hölle, gefangen in einer Endlosschleife...',
      author: 'Philipp Fuchs',
      category: 'Allgemein'
    }
  ];

  return (
    <div className="min-h-screen bg-[#010003] flex flex-col">
      <NavigationWrapper />
      
      <section className="relative z-10 bg-[#010003] pt-48 pb-24">
        <div className="w-[1080px] mx-auto">
          {/* Filter Labels */}
          <div className="flex items-center gap-3 mb-12">
            {filters.map((filter) => (
              <button
                key={filter}
                onClick={() => setActiveFilter(filter)}
                className={`px-4 py-2 rounded-full text-sm font-geist tracking-[-0.02em] transition-colors ${
                  activeFilter === filter
                    ? 'bg-white text-black'
                    : 'bg-transparent text-white hover:bg-white/10'
                }`}
              >
                {filter}
              </button>
            ))}
          </div>

          {/* Main Blog Posts Grid */}
          <div className="grid grid-cols-3 gap-6 mb-20">
            {mainPosts.map((post) => (
              <Link 
                key={post.id}
                to={`/blog/${post.slug}`}
                className="block"
              >
                <article className="group bg-transparent border border-[#16181d] rounded-xl p-8 hover:border-white/30 transition-all duration-300 cursor-pointer h-full flex flex-col">
                  {/* BLCKS Icon and Date */}
                  <div className="flex justify-between items-start mb-6">
                    <div className="w-12 h-12 flex items-center justify-center">
                      <img 
                        src={blcks_icon_white}
                        alt="BLCKS AI" 
                        className="w-10 h-10"
                      />
                    </div>
                    <div className="text-[#787c87] text-xs font-geist tracking-[0.01em] pt-1">
                      {post.date}
                    </div>
                  </div>

                  {/* Title */}
                  <h3 className="text-white text-2xl font-geist font-normal tracking-[-0.02em] mb-4 leading-tight">
                    {post.title}
                  </h3>

                  {/* Excerpt */}
                  <div className="relative flex-grow mb-6 overflow-hidden">
                    <div className="relative">
                      <p className="text-[#787c87] text-sm font-geist font-light tracking-[0.01em] leading-relaxed">
                        {post.excerpt}
                      </p>
                      <div className="absolute bottom-0 left-0 right-0 h-12 bg-gradient-to-t from-[#010003] to-transparent pointer-events-none"></div>
                    </div>
                  </div>

                  {/* Author */}
                  <div className="flex items-center gap-2 mt-auto">
                    <div className="w-6 h-6 rounded-full">
                      <img 
                        src={philteamfoto} 
                        alt="Philipp Fuchs" 
                        className="w-full h-full object-cover"
                      />
                    </div>
                    <span className="text-[#787c87] text-sm font-geist tracking-[0.01em]">
                      {post.author}
                    </span>
                  </div>
                </article>
              </Link>
            ))}
          </div>

          {/* Latest News Section */}
          <div>
            <h2 className="text-white text-4xl font-geist font-normal tracking-[-0.02em] mb-12 pl-8">
              Latest Posts.
            </h2>

            <div className="grid grid-cols-3 gap-28 p-8">
              {latestNews.map((post) => (
                <Link 
                  key={post.id}
                  to={`/blog/${post.slug || 'ki-basierte-wissensdatenbanken'}`}
                  className="group flex flex-col h-full"
                >
                  <article className="group flex flex-col h-full">
                  <div className="flex-grow">
                    {/* Category and Date */}
                    <div className="flex items-center justify-between mb-3">
                      <span className="text-[#787c87] text-xs font-geist tracking-[0.01em]">
                        {post.category}
                      </span>
                      <span className="text-[#787c87] text-xs font-geist tracking-[0.01em]">
                        {post.date}
                      </span>
                    </div>

                    {/* Title */}
                    <h3 className="text-white text-xl font-geist font-normal tracking-[-0.02em] mb-3 leading-tight hover:text-gray-300 transition-colors cursor-pointer">
                      {post.title}
                    </h3>

                    {/* Excerpt */}
                    <p className="text-[#787c87] text-sm font-geist font-light tracking-[0.01em] leading-relaxed mb-4 hover:text-gray-400 transition-colors cursor-pointer">
                      {post.excerpt}
                    </p>
                  </div>

                  {/* Author - This will now align at the bottom of each card */}
                  <div className="flex items-center gap-2 mt-auto">
                    <div className="w-5 h-5 rounded-full flex-shrink-0">
                      <img 
                        src={philteamfoto} 
                        alt="Philipp Fuchs" 
                        className="w-full h-full object-cover"
                      />
                    </div>
                    <span className="text-[#787c87] text-xs font-geist tracking-[0.01em] truncate">
                      {post.author}
                    </span>
                  </div>
                </article>
                </Link>
              ))}
            </div>
          </div>
        </div>
      </section>
      
      <FooterWrapper />
    </div>
  );
};

export default Blog;